var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPasswordReset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 158,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M75 158c41.421 0 75-33.579 75-75S116.421 8 75 8 0 41.579 0 83s33.579 75 75 75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFEAFB",
    d: "M83 79H39a3 3 0 1 0 0 6h44a3 3 0 1 0 0-6ZM83 106H39a3 3 0 1 0 0 6h44a3 3 0 1 0 0-6ZM83 133H39a3 3 0 1 0 0 6h44a3 3 0 1 0 0-6Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3D71E8",
    d: "M42 87h67v19H42z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M50.228 111.168h9.428v11.105l14.633-11.105h26.761c8.08 0 14.655-6.589 14.655-14.694l-.056-.321c0-8.082-6.575-14.656-14.663-14.656l-50.834.056c-8.079 0-14.654 6.575-14.654 14.655l.053.36c0 8.083 6.58 14.6 14.677 14.6Zm42.52-16.575 1.569-2.716 3.013 1.74v-3.48h3.137v3.48l3.013-1.74 1.568 2.717-3.011 1.739 3.011 1.739-1.568 2.717-3.013-1.74v3.479H97.33V99.05l-3.013 1.739-1.569-2.717 3.012-1.739-3.012-1.74Zm-15.53 0 1.568-2.716 3.013 1.74v-3.48h3.136v3.48l3.014-1.74 1.568 2.717-3.013 1.739 3.013 1.739-1.568 2.717-3.014-1.74v3.479H81.8V99.05l-3.013 1.739-1.568-2.717 3.012-1.739-3.012-1.74Zm-15.532 0 1.569-2.716 3.013 1.74v-3.48h3.137v3.48l3.013-1.74 1.568 2.717-3.012 1.739 3.012 1.739-1.568 2.717-3.013-1.74v3.479h-3.137V99.05l-3.014 1.739-1.568-2.717 3.013-1.739-3.013-1.74Zm-15.53 0 1.568-2.716 3.013 1.74v-3.48h3.137v3.48l3.013-1.74 1.569 2.717-3.012 1.739 3.012 1.739-1.569 2.717-3.013-1.74v3.479h-3.137V99.05l-3.013 1.739-1.568-2.717 3.012-1.739-3.012-1.74Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3D71E8",
    d: "m77.555 76.362.194 2.314h19.053V69.58c0-3.95-2.267-7.407-5.554-9.146h-.019V54.06c0-8.598-7.01-15.627-15.628-15.627-8.617 0-15.626 7.03-15.626 15.627v6.356h-.02c-3.307 1.738-5.555 5.196-5.555 9.164v9.097h19.055l.193-2.3a3.243 3.243 0 0 1-1.315-2.618 3.255 3.255 0 0 1 3.261-3.261 3.267 3.267 0 0 1 3.276 3.26 3.232 3.232 0 0 1-1.316 2.605ZM66.002 59.263V54.06c0-5.272 4.309-9.58 9.6-9.58 5.29 0 9.599 4.308 9.599 9.58v5.203H66.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2BDFA",
    d: "m122.059 52.483-2.593 1.647c12.469 19.628 10.287 45.402-5.304 62.676-15.593 17.271-41.008 22.073-61.8 11.676a62.363 62.363 0 0 1-2.004-1.063 52.86 52.86 0 0 1-8.821-6.228l5.257-.269-.157-3.067-10.541.539.54 10.54 3.067-.156-.274-5.35a55.935 55.935 0 0 0 9.436 6.674c.697.386 1.402.762 2.116 1.123a54.772 54.772 0 0 0 27.333 5.702c14.262-.73 28.11-6.967 38.128-18.064 16.513-18.294 18.822-45.59 5.617-66.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1F58D8",
    d: "M37.042 47.192C52.638 29.915 78.05 25.12 98.858 35.54c.607.294 1.261.637 1.997 1.05a52.848 52.848 0 0 1 8.829 6.233l-5.275.27.157 3.068 10.54-.54-.539-10.54-3.068.156.273 5.333a55.932 55.932 0 0 0-9.418-6.66 40.935 40.935 0 0 0-2.141-1.125c-22.017-11.027-48.933-5.947-65.45 12.35-16.513 18.294-18.824 45.591-5.618 66.381l2.593-1.646c-12.47-19.63-10.288-45.403 5.304-62.677Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 75,
    x2: 75,
    y1: 8,
    y2: 158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.611 27h109.982v110H20.611z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 92.207,
    height: 52.776,
    x: 29.498,
    y: 72.497,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_21_6387"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_21_6387",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordReset);
export default __webpack_public_path__ + "static/media/password-reset.0ef96dd06e91711edd466269e6b48757.svg";
export { ForwardRef as ReactComponent };